module.exports = __webpack_public_path__ + "static/media/iPhone-12-Pro.755fa787.svg";